export const environment = {
  production: false,
  apiGatewayBaseURL: 'https://oxo-staging.yallaomni.com/Gateway',
  authServerBaseURL: 'https://oxo-staging.yallaomni.com',
  base_href: '/settings/',
  wikiApiBaseURL: 'https://llm-wiki.silqfi.xyz/public/v1',
  // Ask AI chat: points the chat SSE endpoint straight at our own backend instead of the CHAT-13
  // gateway proxy. Set here (the staging build) so Abdullah can test/demo the chat on oxo-staging
  // via the direct-token path while proxy-trust + mTLS are still being wired. Staging only — the
  // portal token stays inside oxo-staging's trust boundary (the same auth server this env uses).
  // NOTE: this file is also what `ng serve` uses by default, so local dev now hits staging chat too.
  // Revert to '' once the CHAT-13 proxy path is live. environment.prod.ts stays '' — prod always
  // goes through the gateway proxy.
  chatLocalBaseURL: '',
  // Zoho Desk Business Messaging support chat (OMNI-3430): the channel from its embed snippet in Zoho
  // Desk (Setup > Channels > Instant Messaging > Business Messaging). Empty = not configured; the Ask
  // panel's "Technical support" tab then says support is unavailable.
  zohoImChannel: {
    baseUrl: 'https://im.zoho.in',
    channelId: 'e4fbe125e2085dcbb6ea6d4be9e7a736',
  },
  // Microsoft Clarity session recording (OMNI-3598): production only, so empty here.
  clarityProjectId: '',
  authSettings: {
    clientId: 'angularclient',
  }
};
